import React, { ChangeEvent, useEffect, useState } from "react";
import {
  collection,
  doc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { NewProjectProfileType } from "../Types/projectProfile";
import { app } from "../lib/firebase";
import styles from "../Projects/Project.module.css";
import WelcomePage from "../WelcomePage/WelcomePage";
import UserExperiment from "./SharedDataExperiment";
import { NewProjectExperimentType } from "../Types/projectExperiment";

const db = getFirestore(app);

//The goal here is to have the user select the project for which to perform
//an experiment.

//Do a firebase query where userID = currentUserID against the projectExperiments
//collection and place the titles into an array

//User the array to fill the values of a listbox

//The listbox selection will then perform a fetch to firebase to
//retrieve the details of the project and fill out that information on the page

//When the user is satisfied that have the correct project then they click proceed button.

//The click of the proceed button will take the project title selected and place that
//in global storage and then switching to the UserExperiment Page

//The UserExperiment module will in turn use the title value in a query to firebase
//to fetch all the experiments that the user has performed for that project title

//When the compilation of experiments has been gathered then UserExperiment will
//call ExperimentInformation and pass to it the docs via in an IProp interface
const tempUser = localStorage.getItem("userUID")!;
let projectTitlesIndex = 0;
let projectTitles: string[] = [];
let projectDescriptions: string[] = [];
let projectDetailedDescriptions: string[] = [];
let projectHashtags: string[] = [];

function SharedDataProjectSelect() {
  const [projectTitleInput, setProjectTitleInput] = useState("");

  const [projectDescriptionInput, setProjectDescriptionInput] = useState("");

  const [projectDetailedDescriptionInput, setProjectDetailedDescriptionInput] =
    useState("");

  const [projectHashtagsInput, setProjectHashtagsInput] = useState("");

  const [projectProfiles, setProjectProfiles] = useState<
    NewProjectProfileType[]
  >([]);

  const [prjectProfiles, setPrjectProfiles] = useState<NewProjectProfileType[]>(
    []
  );

  const [prjExperiments, setPrjExperiments] = useState<
    NewProjectExperimentType[]
  >([]);

  const [displayValue, setDisplayValue] = useState("Small");

  //const ProceedButtonClicked = () => {
  //  console.log(" arg is ", projectTitlesIndex);
  //  console.log(" local storage is ", localStorage.getItem("projectTitle"));
  //localStorage.setItem("value", value);
  //  console.log(" value = ", localStorage.getItem("value"));
  //UserExperiment();
  //};

  const ProjectSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("project selected entered...");
    const projectTitlesIndex = e.currentTarget.selectedIndex - 1;
    //localStorage.setItem("projectTitle", projectTitles[projectTitlesIndex]);
    console.log(" project selected values is ", e.target.value);
    console.log(" project selected index is ", projectTitlesIndex);
    setProjectTitleInput(projectTitles[projectTitlesIndex]);
    setProjectDescriptionInput(projectDescriptions[projectTitlesIndex]);
    setProjectDetailedDescriptionInput(
      projectDetailedDescriptions[projectTitlesIndex]
    );
    setProjectHashtagsInput(projectHashtags[projectTitlesIndex]);

    localStorage.setItem("projectTitle", projectTitles[projectTitlesIndex]);
  };

  // Query all experiments and retrieve
  const q0 = query(
    collection(db, "projectExperiments"),
    orderBy("experimentDate", "desc")
  );

  useEffect(
    () =>
      onSnapshot(q0, (snapshot) => {
        return setPrjExperiments(
          snapshot.docs.map((doc) => {
            console.log(
              "projectExperiments snapshot and doc.data() = ",
              doc.data()
            );
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  console.log("prjExperiments = ", prjExperiments);

  let docRefArray: string[] = [];

  const projectTitlesLength = projectTitles.length;
  let tempProject: NewProjectProfileType;

  console.log("user is = ", tempUser);
  const q1 = query(
    collection(db, "projectProfiles"),
    where("title", "!=", ""),
    where("access", "==", "public"),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q1, (snapshot) => {
        setProjectProfiles(
          snapshot.docs.map((doc) => {
            tempProject = projectProfiles;
            if (doc.id) {
              docRefArray.push(doc.id);
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  console.log("projectProfiles = ", projectProfiles);
  // Now, we need to go through each project and then go through each experiment
  // in the project (if any) and discover if any of the experiments
  // contain data that is shareable or shareable with permission. Those projects will
  // be copied to a new arry and those will be displayed in the listbox. If only one
  // experiment has shared data then it qualifies the project as containing such.
  // One is enough the potentially multiple experiments will be covered in the next
  // module...all we care about here are which projects to display

  let tempShareable = "";
  let l = 0;
  console.log("projectProfiles.length  = ", projectProfiles.length);
  console.log("prjExperiments.length = ", prjExperiments.length);
  //For each project
  for (let i = 0; i < projectProfiles.length; i++) {
    //console.log("projectProfiles[i].title = ", projectProfiles[i].title);
    //For each experiment
    let addProject = true;
    for (let j = 0; j < prjExperiments.length && addProject; j++) {
      //Check the current project and experiment titles for equality
      //console.log(
      //  "prjExperiments[j].experimentTitle = ",
      //  prjExperiments[j].projectTitle
      //);
      if (projectProfiles[i].title === prjExperiments[j].projectTitle) {
        //They match, so if experimentData exists
        console.log("Titles match found between project and experiment");
        if (prjExperiments[j].experimentData !== undefined) {
          console.log(
            "prjExperiments[j].experimentData.length = ",
            prjExperiments[j].experimentData.length
          );
          //Loop through the experimentData entries
          for (
            let k = 0;
            k < prjExperiments[j].experimentData.length && addProject;
            k++
          ) {
            console.log("k = ", k);
            if (prjExperiments[j].experimentData[k] !== undefined) {
              //Loop through the experimentData entries
              console.log("not undefined");
              for (const [key, value] of Object.entries(
                prjExperiments[j].experimentData[k]
              )) {
                console.log("comparing keys ");
                //If the key is dataShareable
                if (key === "dataShareable") {
                  tempShareable = value;
                  console.log("dataShareable = ", tempShareable);
                  //If dataShareable === "Yes" or "With Consent"
                  if (
                    tempShareable === "Yes" ||
                    tempShareable === "With Consent"
                  ) {
                    //Add this project to new array and break for next project
                    prjectProfiles[l] = projectProfiles[i];
                    console.log("added project = ", prjectProfiles[l]);
                    l++;
                    addProject = false;
                    break;
                    //We can skip the rest of the entries for this experimentData
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  //let uniqueCountries = countries.reduce(function (a, b) {
  //  if (a.indexOf(b) < 0) a.push(b);
  //  return a;
  //}, []);
  //Have to change projectProfiles to be the new array
  console.log(" before if prjectProfiles = ", prjectProfiles);
  if (prjectProfiles !== undefined) {
    //The array of full objects with id as the key
    //What we'd like to do here is to create a new array consisting of just
    //The project titles (projectTitle) and that array will provide for the list box
    console.log(" project profiles length is = ", prjectProfiles.length);
    for (let i = 0; i < prjectProfiles.length; i++) {
      projectTitles[i] = prjectProfiles[i].title;
      projectDescriptions[i] = prjectProfiles[i].description;
      projectDetailedDescriptions[i] = prjectProfiles[i].detailedDescription;
      projectHashtags[i] = prjectProfiles[i].projectHashtags;
    }
  }
  console.log("displayValue = ", displayValue);
  localStorage.setItem("displayValue", displayValue);
  console.log(
    "displayValue from localStorage = ",
    localStorage.getItem("displayValue")
  );
  return (
    <>
      <div className={styles.wrapper} />
      <div className={styles.top}>
        <h2 className={styles.header} style={{ marginLeft: 50 }}>
          Shared Data Project Selection
        </h2>
        <div> &emsp;</div>
        <label
          className={styles.forh3}
          style={{ marginLeft: 50, fontWeight: 550 }}
        >
          Instructions
        </label>
        <input
          className={styles.messageText}
          style={{ marginLeft: 89, width: 655 }}
          type="text"
          readOnly
          value="Select a project which shares its data then proceed to view the experiment and download the data generated"
        />
        <div> &emsp;</div>
        <div> &emsp;</div>
        <div>
          <label
            className={styles.forh3}
            style={{ marginLeft: 50, fontWeight: 550 }}
          >
            Projects
          </label>
          <select
            name="Project List"
            id="project-select"
            onChange={ProjectSelected}
            style={{ marginLeft: 117 }}
          >
            <option value="">-- Project Selections --</option>
            {projectTitles.map((projectTitles, key) => (
              <option key={key} value={projectTitles}>
                {projectTitles}
              </option>
            ))}
          </select>
        </div>
        <div className={styles.forh3}>
          <br />
          <label style={{ marginLeft: 50, fontWeight: 550 }}>
            Project Title
          </label>
          <input
            className={styles.messageText}
            style={{ marginLeft: 87, width: 475 }}
            type="text"
            readOnly
            value={projectTitleInput}
          />
          <br />
          <br />
        </div>
        <div className={styles.aimLabel}>
          <label style={{ marginLeft: 30, fontWeight: 550 }}>
            Project Description
          </label>
          <textarea
            className={styles.messageText}
            rows={4}
            cols={80}
            style={{ marginLeft: 30, width: 475, height: 60 }}
            readOnly
            value={projectDescriptionInput}
          />
        </div>
        <div> &emsp;</div>

        <div className={styles.aimLabel}>
          <label style={{ marginLeft: 30, fontWeight: 550 }}>
            Detailed Description
          </label>
          <textarea
            className={styles.messageText}
            rows={4}
            cols={80}
            style={{ marginLeft: 20, width: 475, height: 80 }}
            readOnly
            value={projectDetailedDescriptionInput}
          />
        </div>
        <div> &emsp;</div>

        <div className={styles.aimLabel}>
          <label style={{ marginLeft: 30, fontWeight: 550 }}>
            Project Hashtags
          </label>
          <textarea
            className={styles.messageText}
            rows={3}
            cols={80}
            style={{ marginLeft: 43, width: 475, height: 35 }}
            readOnly
            value={projectHashtagsInput}
          />
        </div>
        <div> &emsp;</div>

        <div style={{ marginLeft: 223 }}>
          <input
            type="radio"
            name="radioCheck"
            value="Small"
            checked
            onChange={(e) => {
              setDisplayValue(e.target.value);
              localStorage.setItem("displayValue", displayValue);
            }}
          />
          View the data generation experiment <br></br>
          <br></br>
          <input
            type="radio"
            name="radioCheck"
            value="Large"
            onChange={(e) => {
              setDisplayValue(e.target.value);
              localStorage.setItem("displayValue", displayValue);
            }}
          />
          View the data generation experiment and all its preceeding and
          proceeding experiments
        </div>
        <br></br>
        <div className={styles.aimLabel}>
          <a href="SharedDataExperiment">
            <button
              id="proceedButtonID"
              className={styles.buttonClass}
              style={{ marginLeft: 181, marginBottom: -21 }}
            >
              Proceed
            </button>
          </a>
          <a href="WelcomePage">
            <button
              className={styles.buttonClass}
              style={{ marginLeft: 10, marginTop: 0 }}
            >
              Close
            </button>
          </a>
        </div>
      </div>
    </>
  );
}

export default SharedDataProjectSelect;
